var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FormControl } from '@mui/material';
import { StyledInputLabel, StyledSelect, StyledFormHelperText } from './Select.styles';
const Select = forwardRef((_a, ref) => {
    var { id, children, error, value, label, size = 'medium', onChange, fullWidth = true, helperText } = _a, selectProps = __rest(_a, ["id", "children", "error", "value", "label", "size", "onChange", "fullWidth", "helperText"]);
    return (_jsxs(FormControl, { size: size, error: error, fullWidth: fullWidth, variant: 'outlined', children: [_jsx(StyledInputLabel, { id: id, children: label }), _jsx(StyledSelect, Object.assign({}, selectProps, { ref: ref, value: value, variant: 'outlined', label: label, labelId: id, onChange: onChange, children: children })), helperText && _jsx(StyledFormHelperText, { children: helperText })] }));
});
export default Select;
